"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var base_service_1 = require("./src/base-service");
exports.BhtpBaseService = base_service_1.BhtpBaseService;
__export(require("./src/models/"));
var session_storage_service_1 = require("./src/session-storage.service");
exports.SessionStorage = session_storage_service_1.SessionStorage;
var local_storage_service_1 = require("./src/local-storage.service");
exports.LocalStorage = local_storage_service_1.LocalStorage;
//# sourceMappingURL=D:/a/1/s/base/index.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/index.js